<!--
 * @Description: 项目管理员权限下的工程管理页面
 * @Author:
 * @Date: 2022-08-15 11:44:06
 * @LastEditTime: 2026-01-15 16:51:29
 * @LastEditors: dongqianqian
 * @Usage:
-->

<template>
  <el-row class="engineerDetail">
    <el-col :span="6">
      <!-- <el-scrollbar
              wrapClass="scrollbar-wrap"
              :style="{height: scrollHeight}"
              ref="scrollbarContainer"> -->
      <div
        class="content-enginner"
        ref="enginner"
      >
        <el-form
          ref="form"
          :model="searchForm"
          label-width="130px"
          :rules="rules"
        >
          <el-col :span="20">
            <el-form-item label="工程名称:">
              <el-input
                v-model="searchForm.authorityProjectName"
                :disabled="isEdit"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item
              label="工程简称:"
              prop="authorityProjectSimpleName"
            >
              <el-input
                v-model="searchForm.authorityProjectSimpleName"
                :disabled="isEdit"
                :maxlength=10
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="建设单位:">
              <el-input
                v-model="searchForm.projectOwner"
                :disabled="isEdit"
                :maxlength=30
                placeholder="请输入建设单位名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="施工单位:">
              <el-input
                v-model="searchForm.contractor"
                :disabled="isEdit"
                :maxlength=30
                placeholder="请输入施工单位名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="监理单位:">
              <el-input
                v-model="searchForm.supervisionUnit"
                :disabled="isEdit"
                :maxlength=30
                placeholder="请输入监理单位名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="工程编号:">
              <el-input
                v-model="searchForm.authorityProjectCode"
                :disabled="isEdit"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="工程地点:">
              <el-cascader
                :disabled="isEdit"
                size="large"
                :options="regionOptions"
                style="width:100%;"
                v-model="searchForm.selectedOptions"
                @change="placeChange"
              ></el-cascader>
              <!-- <el-cascader
                style="width: 100%"
                ref="cascaderAddr"
                v-model="searchForm.engineerPlace"
                :options="options"
                @change="handleChange"
                :disabled="isEdit"
              ></el-cascader> -->
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="详细地址:">
              <el-input
                v-model="searchForm.address"
                :disabled="isEdit"
                @input="hanlderInput"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="计划开工时间:">
              <el-date-picker
                style="width: 100%"
                type="date"
                v-model="searchForm.planBeginTime"
                placeholder="选择日期"
                @change="dateChange"
                :disabled="isEdit"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>

            </el-form-item>
          </el-col>
          <!-- 竣工时间比开工时间晚，早的时间不可选 -->
          <el-col :span="20">
            <el-form-item label="计划竣工时间:">
              <el-date-picker
                style="width: 100%"
                v-model="searchForm.planEndTime"
                type="date"
                :disabled="isEdit"
                placeholder="选择日期"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="工程状态:">
              <el-select
                v-model="searchForm.projectStatus"
                placeholder="请选择"
                style="width: 100%"
                :disabled="isEdit"
              >
                <el-option
                  v-for="item in statusOptions"
                  :key="item.name"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="合同金额（元）:">
              <el-input
                v-inputFloat
                v-model="searchForm.contractAmount"
                :disabled="isEdit"
                placeholder="输入数字或小数"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="工程规模:">
              <el-input
                v-model="searchForm.projectArea"
                :disabled="isEdit"
                style="width: 60%"
              ></el-input>
              <el-select
                v-model="searchForm.projectUnit"
                placeholder="请选择"
                style="width: 35%"
                :disabled="isEdit"
              >
                <el-option
                  v-for="item in unitList"
                  :key="item.projectUintName"
                  :label="item.projectUintName"
                  :value="item.projectUintName"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 工程类型选择为房建工程时，结构类型才可选择，否则为不可选择状态 -->
          <el-col :span="20">
            <el-form-item label="工程类型:">
              <el-select
                v-model="searchForm.authorityProjectTypeId"
                placeholder="请选择"
                style="width: 100%"
                :disabled="isEdit"
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            :span="20"
            v-show="searchForm.authorityProjectTypeId == '1'"
          >
            <el-form-item label="施工阶段:">
              <el-select
                v-model="searchForm.projectStage"
                placeholder="请选择"
                style="width: 100%"
                :disabled="isEdit"
              >
                <el-option
                  v-for="item in stageOptions"
                  :key="item.name"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="结构类型:">
              <el-select
                v-model="searchForm.structType"
                placeholder="请选择"
                style="width: 100%"
                :disabled="isEdit"
              >
                <el-option
                  v-for="item in structureOptions"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="适用规范:">
              <el-select
                v-model="searchForm.useType"
                placeholder="请选择"
                style="width: 100%"
                :disabled="isEdit"
              >
                <el-option
                  v-for="item in applicableOptions"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="施工许可证:">
              <el-input
                v-model="searchForm.constructionPermit"
                :disabled="isEdit"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="LOGO:">
              <upload
                ref="apload"
                storageName="projectLogo"
                :defaultUrl="searchForm.logoImage"
                :action="uploadImgUrl"
                :disabled="isEdit"
                :dialog="false"
                :autoUpload="true"
                :isSaveData="true"
                listType="picture"
                :on-change="handleChange"
                formFile="files"
                :show-file-list="false"
                @imgUrl="getImgUrl"
                :file-list="fileList"
                :httpurl="searchForm.logoImage"
              >
              </upload>
              <!-- :file-list="fileListLogo" -->
              <!-- <Upload
                ref="upload"
                storageName="projectLogo"
                :action="uploadData"
                :disabled="isEdit"
                :dialog="false"
                :autoUpload="true"
                :isSaveData="true"
                :showFileList="true"
              ></Upload> -->
              <span style="color: red; display: inline">*平台左上角LOGO</span>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="平台名称:">
              <el-input
                v-model="searchForm.platFormName"
                :disabled="isEdit"
                placeholder="建议字数在25字以内"
                maxlength="40"
              ></el-input>
              <span style="color: red; display: block">*平台左上角文字</span>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="首页视频:">
              <upload
                ref="bpload"
                storageName="homeVideoPath"
                :defaultUrl="searchForm.indexVideo"
                :action="uploadVideoUrl"
                :disabled="isEdit"
                :dialog="false"
                :autoUpload="true"
                :isSaveData="true"
                listType="video"
                :on-change="handleChangeVideo"
                :videoFile="true"
                :showFileList="true"
                formFile="files"
                :show-file-list="false"
                :file-list="videoList"
                @imgUrl="getVideoUrl"
                :httpurl="searchForm.indexVideo"
              ></upload>
              <span style="color: red">*平台首页视频</span>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="首页图片:">
              <upload
                ref="apload"
                :defaultUrl="searchForm.indexImage"
                :action="uploadImgUrl"
                :disabled="isEdit"
                :dialog="false"
                :autoUpload="true"
                :showFileList="false"
                :isSaveData="true"
                listType="picture"
                formFile="files"
                @imgUrl="getHomeImg"
                :httpurl="searchForm.indexImage"
              ></upload>
              <!-- <upload
                ref="apload"
                storageName="homePicPath"
                :defaultUrl="searchForm.indexImage"
                :action="uploadHomeUrl"
                :disabled="isEdit"
                :dialog="false"
                :autoUpload="true"
                :showFileList="false"
                :isSaveData="true"
                listType="picture"
                @imgUrl="getHomeImg"
              ></upload> -->
              <span style="color: red">*平台首页图片</span>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <!-- </el-scrollbar> -->
    </el-col>
    <!-- 地图部分 -->
    <el-col
      :span="18"
      class="map-content"
    >
      <el-col>
        <Bamap
          v-if="projectInfo"
          class="bai-map"
          :selectAddress="selectAddress"
          @mapPoint="getMapPoint"
          :companyInfo="projectInfo"
        ></Bamap>
      </el-col>
      <el-col
        align="center"
        class="btn-bottom"
      >
        <el-button
          type="primary"
          size="medium"
          @click="editClick"
          v-show="isEdit"
        >编 辑</el-button>
        <el-button
          type="primary"
          @click="sureClick"
          v-show="!isEdit"
        >确 定</el-button>
        <el-button
          @click="closeClick"
          v-show="!isEdit"
        >取 消</el-button>
        <el-button
          @click="addDic"
          v-if="addDicShow"
        >添加字典</el-button>
      </el-col>
    </el-col>
  </el-row>
</template>
<script>
import { regionData } from "element-china-area-data";
import { BASE_PLATFORMLOGO_URL } from "@/util/constant.js";
import { getProjectExtend, saveProjectExtend } from "@/api/engineer-detail.js";
import {
  Api_SuperAdmin,
  Api_Base,
  Api_System
} from "@/api/api.js";
import { addDicData } from "@/api/pubapi";
import upload from "@/pub/components/upload.vue";
import Bamap from "@/components/bamap.vue";
import { getStore } from '@/util/store';
import _ from 'lodash'
// let id = 0;
export default {
  components: { upload, Bamap },
  name: "engineerDetail",
  data() {
    return {
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now(this.searchForm.planBeginTime);
        // },
      },
      selectAddress: '',
      fileList: [],
      videoList: [],
      regionOptions: regionData,
      selectedOptions: [],
      unitList: [],
      uploadImgUrl: "",
      uploadHomeUrl: "",
      addDicShow: false,
      isEdit: true,
      options: [],
      statusOptions: [],
      stageOptions: [],
      typeOptions: [],
      structureOptions: [],
      applicableOptions: [],
      fileListLogo: [{ name: '', url: '' }],
      searchForm: {
        selectedOptions: [],
        authorityProjectName: "", //工程名称
        authorityProjectSimpleName: "",//工程简称
        projectOwner: "", // 建设单位
        contractor: "", // 施工单位
        supervisionUnit: "", // 监理单位
        authorityProjectCode: "", //工程编号
        provinceId: '', //省份
        cityId: '', //城市
        areaId: '', //地区
        address: "", //工程详细地址
        planBeginTime: "", //计划开工时间
        planEndTime: "", //计划竣工时间
        projectStatus: 0, //工程状态
        projectStage: 0, // 施工阶段
        contractAmount: "", // 合同金额
        projectArea: "", //工程规模
        projectUnit: '', //规模单位
        authorityProjectTypeId: 0, //工程类型
        structType: '', //结构类型
        useType: 0, //适用规范
        constructionPermit: "", //施工许可证
        logoImage: "", //项目图标
        // logoFile:'', //logo文件 带file传参
        platFormName: "", //平台名称
        indexVideo: "", //首页视频地址  //带path返回
        // homeVideoFile:"", //视频文件
        indexImage: "", //首页图片地址
        // homePicFile: "", //首页图片文件
        pointX: '', // 经度坐标
        pointY: '', // 纬度坐标
      },
      scrollHeight: "0px",
      projectId: '',
      dicArr: [
        {
          name: "工程状态",
          list: "statusOptions",
        },
        {
          name: "施工阶段",
          list: "stageOptions",
        },
        {
          name: "工程类型",
          list: "typeOptions",
        },
        {
          name: "结构类型",
          list: "structureOptions",
        },
        {
          name: "适用规范",
          list: "applicableOptions",
        },
        {
          name: "工程规模",
          list: "unitList",
        },
      ],
      projectInfo: null,
      rules: {
        authorityProjectSimpleName: [
          { required: true, message: '请输入项目简称，不超过10个字', trigger: 'blur' },
        ]
      }
    };
  },
  created() {
    this.projectId = getStore({ name: 'projectId' })
    this.uploadImgUrl = `${Api_Base.upLoadFile}/1`
    this.uploadHomeUrl = `${Api_Base.upLoadFile}/1`
    this.uploadVideoUrl = `${Api_Base.upLoadFile}/3`
    // this.getDicData();
    this.getData()
    this.getUnits()
    this.getProjectType()
    this.getProjectStatus()
    this.getStructList()
    this.getUseTypeList()
    this.getProjectStages()
  },

  mounted() {
    this.$refs.enginner.style.height = '640px';
  },
  methods: {
    /**
     * @description: 从地图中获取坐标点传递给后端
     * @param {*} point
     * @return {*}
     */
    getMapPoint(point) {
      this.searchForm.pointX = point.lng
      this.searchForm.pointY = point.lat
    },
    getVideoUrl(file) {
      this.searchForm.indexVideo = file.fileUrl
      this.videoList = file
    },
    hanlderInput: _.debounce(function () {
      this.getSelectTree(this.searchForm.selectedOptions)
    }, 1000),
    getSelectTree(val) {
      if (!val.length) return
      // TODO 树状结构遍历待优化
      let province = ''
      let city = ''
      let area = ''
      this.regionOptions.map(p => {
        if (p.value === val[0]) {
          province = p.label
          // 检查是否有children属性，支持香港等只有两级的地区
          if (p.children && Array.isArray(p.children)) {
            p.children.map(c => {
              if (c.value === val[1]) {
                // 检查是否有第三级children，判断是三级还是两级结构
                if (c.children && Array.isArray(c.children) && c.children.length > 0) {
                  // 三级结构：省-市-区
                  city = c.label
                  if (val[2]) {
                    c.children.map(a => {
                      if (a.value === val[2]) {
                        area = a.label
                      }
                    })
                  }
                } else {
                  // 两级结构：省-区（如香港、澳门）
                  // 将第二级作为区处理
                  area = c.label
                }
              }
            })
          }
        }
      })
      // 拼接地址，添加适当的空格分隔，便于地图定位
      // 对于香港、澳门等特别行政区，使用更简洁的格式
      let provinceName = province
      if (province && (province.includes('香港') || province.includes('澳门'))) {
        // 将"香港特别行政区"简化为"香港"，便于地图API解析
        provinceName = province.includes('香港') ? '香港' : '澳门'
      }

      let addressParts = [provinceName, city, area].filter(part => part) // 过滤空字符串
      let fullAddress = addressParts.join('')
      if (this.searchForm.address) {
        fullAddress += this.searchForm.address
      }
      this.selectAddress = fullAddress
      return this.selectAddress
    },
    handleChangeVideo(file) {
      this.videoList = [];
      this.videoList.push(file);
    },
    handleChange(file) {
      this.fileList = [];
      this.fileList.push(file);
    },
    // 获取适用规范列表
    getUseTypeList() {
      Api_Base.getUseTypeList().then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          this.applicableOptions = res.data.data;
          this.applicableOptions.unshift({
            name: '请选择',
            value: 0
          })
        }
      })
    },
    // 获取项目施工阶段
    getProjectStages() {
      Api_Base.getProjectStagesNew().then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          this.stageOptions = res.data.data;
          this.stageOptions.unshift({
            name: '请选择',
            value: 0
          })
        }
      })
    },
    // 获取结构类型列表
    getStructList() {
      Api_Base.getStructList().then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          this.structureOptions = res.data.data;
          this.structureOptions.unshift({
            name: '请选择',
            value: 0
          })
        }
      })
    },
    // 获取所有项目规模单位
    getUnits() {
      Api_SuperAdmin.unitList().then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          this.unitList = res.data.data;
        }
      })
    },
    // 获取项目状态列表
    getProjectStatus() {
      Api_Base.getProjectStatus().then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          this.statusOptions = res.data.data;
          this.statusOptions.unshift({
            name: '请选择',
            value: 0
          })
        }
      })
    },
    // 获取项目状态列表
    getProjectType() {
      Api_System.getProjectType().then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          let arr = res.data.data
          this.typeOptions.unshift({
            name: '请选择',
            value: 0
          })
          arr.map(item => {
            this.typeOptions.push({
              name: item.typeName,
              value: item.id
            })
          })
        }
      })
    },
    //获取数据
    getData() {
      getProjectExtend(this.projectId).then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          this.searchForm = result.data
          this.searchForm.selectedOptions = [
            result.data.provinceId + "",
            result.data.cityId + "",
            result.data.areaId + "",
          ];
          this.searchForm.logoImage = result.data.logoImage
          this.searchForm.indexImage = result.data.indexImage
          this.searchForm.indexVideo = result.data.indexVideo
          this.fileList.push({ url: BASE_PLATFORMLOGO_URL + result.data.logoImage })
          this.videoList.push({ url: BASE_PLATFORMLOGO_URL + result.data.indexVideo })
          this.projectInfo = result.data
          // 直接使用接口返回的地址信息构建selectAddress，确保地图能正确定位
          this.buildSelectAddress(result.data)
        }
      })
    },
    // 构建selectAddress地址字符串
    buildSelectAddress(data) {
      if (!data) return
      let address = ''
      // 对于直辖市（provinceName == cityName），使用 省+区+详细地址
      if (data.provinceName && data.provinceName === data.cityName) {
        address = (data.provinceName || '') + (data.areaName || '') + (data.address || '')
      } else {
        // 对于其他省份，使用 省+市+区+详细地址
        address = (data.provinceName || '') + (data.cityName || '') + (data.areaName || '') + (data.address || '')
      }
      this.selectAddress = address
    },
    getImgUrl(data) {
      this.searchForm.logoImage = data.fileUrl
      this.fileList = data
    },
    getHomeImg(data) {
      this.searchForm.indexImage = data.fileUrl
    },
    dateChange(val) {
      let nowDate = new Date(val).getTime()
      let planEndTime = new Date(this.searchForm.planEndTime).getTime()
      planEndTime - nowDate < 0 && (this.searchForm.planEndTime = '')
      this.pickerOptions = {
        disabledDate(time) {
          return time.getTime() < nowDate;
        },
      }
    },
    placeChange(val) {
      if (!val) return
      this.searchForm.provinceId = val[0] ? val[0] * 1 : 0 //省份
      this.searchForm.cityId = val[1] ? val[1] * 1 : 0 //城市
      this.searchForm.areaId = val[2] ? val[2] * 1 : 0 //地区
      this.getSelectTree(val)
    },
    addDic() {
      let n = 0;
      this.dicArr.forEach((ele) => {
        let params = {
          id: n,
          dicName: ele.name,
          dicCode: n + "",
          parentId: 0,
          sort: 0,
        };
        n++;
        addDicData(params);
      });
    },

    editClick() {
      this.isEdit = false;
    },
    // handleChange(val) {
    //   if (val) {
    //     console.log(this.$refs.cascaderAddr.getCheckedNodes()[0].pathLabels);
    //   }
    // },
    //保存
    sureClick() {

      this.$refs.form.validate(valid => {
        if (valid) {
          this.searchForm.projectStage = this.searchForm.authorityProjectTypeId == '1' ? this.searchForm.projectStage : '-1';
          if (this.searchForm.authorityProjectTypeId == '1' && this.searchForm.projectStage == '-1') {
            this.$message({
              type: "warning",
              message: "请选择施工阶段!",
            });
            return
          }
          saveProjectExtend(this.searchForm).then(res => {
            const result = res.data
            if (result.statusCode == 200) {
              this.getData();
              this.$store.dispatch('getUserInfo')
              this.$message({
                type: "success",
                message: "保存成功!",
              });
              this.isEdit = true;
            }
          })
        }
      })

    },
    //取消
    closeClick() {
      this.isEdit = true;
    },
    uploadFile() { },
    aploadFile() { },
    bploadFile() { },
  },
};
</script>

<style lang="scss" scoped>
.map-content {
  height: 98%;
  // .bai-map {
  //   margin-left: 100px;
  // }
}
.content-enginner {
  overflow-y: auto;
  border: 1px solid #fff;
}
.btn-bottom {
  padding: 10px;
}
</style>
